import React from 'react'

function HospitalRolePermissionManagement() {
  return (
    <div>Role Permission Management</div>
  )
}

export default HospitalRolePermissionManagement